/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTehtrisStatuses200ResponseStatusesInner } from './GetTehtrisStatuses200ResponseStatusesInner';
import {
    GetTehtrisStatuses200ResponseStatusesInnerFromJSON,
    GetTehtrisStatuses200ResponseStatusesInnerFromJSONTyped,
    GetTehtrisStatuses200ResponseStatusesInnerToJSON,
    GetTehtrisStatuses200ResponseStatusesInnerToJSONTyped,
} from './GetTehtrisStatuses200ResponseStatusesInner';

/**
 * 
 * @export
 * @interface TestTehtrisConnection200Response
 */
export interface TestTehtrisConnection200Response {
    /**
     * 
     */
    success: boolean;
    /**
     * 
     */
    message: string;
    /**
     * 
     */
    statusCount?: number;
    /**
     * 
     */
    statuses?: Array<GetTehtrisStatuses200ResponseStatusesInner>;
}

/**
 * Check if a given object implements the TestTehtrisConnection200Response interface.
 */
export function instanceOfTestTehtrisConnection200Response(value: object): value is TestTehtrisConnection200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TestTehtrisConnection200ResponseFromJSON(json: any): TestTehtrisConnection200Response {
    return TestTehtrisConnection200ResponseFromJSONTyped(json, false);
}

export function TestTehtrisConnection200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestTehtrisConnection200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'statusCount': json['statusCount'] == null ? undefined : json['statusCount'],
        'statuses': json['statuses'] == null ? undefined : ((json['statuses'] as Array<any>).map(GetTehtrisStatuses200ResponseStatusesInnerFromJSON)),
    };
}

export function TestTehtrisConnection200ResponseToJSON(json: any): TestTehtrisConnection200Response {
    return TestTehtrisConnection200ResponseToJSONTyped(json, false);
}

export function TestTehtrisConnection200ResponseToJSONTyped(value?: TestTehtrisConnection200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'statusCount': value['statusCount'],
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map(GetTehtrisStatuses200ResponseStatusesInnerToJSON)),
    };
}

